import React, { useEffect, useMemo, useState } from "react";
import { Button, Grid } from "@mui/material";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import { toast } from "react-toastify";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import pencilIcon from "./../../../../assets/icons/editPencil.png";
import editIcon from "./../../../../assets/icons/downArrowWhite.png";
import bin from "./../../../../assets/icons/recycle-binColor.png";
import axios from "axios";
import AddBankDetails from "./components/AddBankDetails.tsx";
import EditBankDetails from "./components/EditBankDetails.tsx";
import RejectionsReason from "./components/RejectionsReason.tsx";

const BankDetailsSetup = () => {
  const columns = [
    {
      field: "restaurantName",
      headerName: "Restaurant Name",
      align: "center",
      renderCell: (params) => (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ gap: "5px", cursor: "pointer" }}
          onClick={() => {
            handleBankDetails(params.row);
          }}
        >
          <span style={{ color: "blue", cursor: "pointer" }}>
            {params.value}
            <img
              src={pencilIcon}
              style={{ width: "1rem", marginLeft: "10px" }}
            />
          </span>
        </div>
      ),
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "accountHolderName",
      headerName: "Account Holder Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "accountNumber",
      headerName: "Account Number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "sortCode",
      headerName: "Sort Code",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "iban",
      headerName: "IBAN",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "documents",
      headerName: "Documents",
      align: "center",
      headerAlign: "center",
      flex: 1,
      width: 50,
      renderCell: (params) => {
        const documentObj = params.row.documentObj?.[0]; // Get the first document object
        const documentName = documentObj?.fileUrls?.[0]?.documentUrl.split('/').pop()|| "Download"; // Default name if not provided
        const documentUrl = documentObj?.fileUrls?.[0]?.documentUrl; // Get the first document URL
    
        const handleDownload = async () => {
          if (!documentUrl) return;
    
          try {
            const response = await fetch(documentUrl);
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute("download", documentName || "document"); // Set default filename if missing
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } catch (error) {
            console.error("Download failed:", error);
          }
        };
    
        return documentUrl ? (
          <span
            style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
            onClick={handleDownload}
          >
            {/* {documentName} */}
            Download
          </span>
        ) : (
          "No Document"
        );
      },
    },
    
    {
      field: "isApproveByAdmin",
      headerName: "Status",
      renderCell: useMemo(
        () => (params) => {
          return (
            <div
              className={`${
                params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5434"
                  ? "approve"
                  : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b543b" ||
                    params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5411"
                  ? "pending"
                  : "reject"
              } RoundedStatus`}
              onClick={() => {
                handleStatusClick(params.row);
              }}
              style={{ cursor: "pointer" }}
            >
              {params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5434" ? (
                "Approve"
              ) : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b543b" ? (
                "Pending"
              ) : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5411" ? (
                "Resubmited"
              ) : (
                <span>
                  Reject
                  <img
                    src={editIcon}
                    style={{ width: "1rem", marginLeft: "10px" }}
                  />
                </span>
              )}
            </div>
          );
        },
        []
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "createdByUserName",
      headerName: "Created By",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
  ];

  const [dataRows, setDataRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openRejectionModal, setOpenRejectionModal] = useState(false);
  const [selectedData, setSelectedData] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [selectedDataRows, setSelectedDatarows] = useState([]);
  const [openConfirmaitonModal, setOpenConfirmaitonModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const restaurant = JSON.parse(localStorage.getItem("restaurant"));
  const apiAddress = process.env.REACT_APP_SECRET;

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    let restaurant = JSON.parse(localStorage.getItem("restaurant"));
    axios
      .get(apiAddress + "/api/RestaurantBankDetails/" + restaurant.id)
      .then((response) => {
        setDataRows(response.data);
      })
      .catch((error) => {
        console.error("Error fetching food categories:", error);
      });
  };

  const handleBankDetails = (prop) => {
    console.log(prop);
    setOpenEditModal(true);
    setSelectedData(prop);
  };

  const handleStatusClick = (prop) => {
    console.log(prop);
    if (prop.isApproveByAdmin == "f07294b7-c94d-4d5e-a064-b1282d5b5435") {
      setOpenRejectionModal(true);
      setSelectedData(prop);
    }
  };

  const deleteBin = () => {};

  const getSelectedData = (e) => {
    console.log(e);
  };

  const handleAddItem = (e) => {
    setOpenAddModal(false);
    setOpenEditModal(false);
    loadData();
  };
  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        mb={2}
      >
        <SweetAlertModal
          headerText={"Are you sure?"}
          bodyText={"You want to delete these categories?"}
          open={openConfirmaitonModal}
          onyes={deleteBin}
          close={() => {
            setOpenConfirmaitonModal(false);
          }}
        />
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <Button
                color="primary"
                size="medium"
                variant="contained"
                style={{ borderRadius: "50%", minWidth: "auto" }}
                onClick={() => setOpenAddModal(true)}
              >
                +
              </Button>
            </Grid>
            <Grid item>
              <div className="roundedCorner">
                <img
                  src={bin}
                  alt="delete"
                  style={{ width: "1rem", cursor: "pointer" }}
                  onClick={() => {
                    selectedDataRows.length === 0
                      ? errorToast("Please select a row")
                      : setOpenConfirmaitonModal(true);
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <CustomDataGrid
        columns={columns}
        dataRows={dataRows}
        getselectedData={getSelectedData}
      />
      {openAddModal && (
        <AddBankDetails
          open={openAddModal}
          dialogType={dialogType}
          onHandleAddItem={handleAddItem}
          setIsSubmitting={setIsSubmitting}
          isSubmitting={isSubmitting}
        />
      )}
      {openEditModal && (
        <EditBankDetails
          open={openEditModal}
          dialogType={dialogType}
          onHandleAddItem={handleAddItem}
          setIsSubmitting={setIsSubmitting}
          isSubmitting={isSubmitting}
          selectedData={selectedData}
        />
      )}
      {openRejectionModal && (
        <RejectionsReason
          open={openRejectionModal}
          onHandleAddItem={() => {
            setOpenRejectionModal(false);
          }}
          selectedData={selectedData}
        />
      )}
    </div>
  );
};

export default BankDetailsSetup;
